import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    color: theme.palette.content.primary,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "100%",
    flexShrink: 0,
  },
  title: {
    fontSize: "18px",
    fontWeight: "500",
    marginBottom: "5px",
    marginTop: "50px",
  },
  content: {
    fontSize: "16px",
    fontWeight: "300",
    marginBottom: "10px",
  },
  startSpace: {
    marginLeft: "6px",
  },
  superscript: {
    position: "absolute",
    fontSize: "8px",
  },
  gap: {
    margin: "10px",
  },
  noContent: {
    "&::before": {
      content: '""',
      height: "0px !important",
    },
  },
  expanded: {
    margin: "0px !important",
  },
  accordion: {
    [theme.breakpoints.up("md")]: {
      height: "36px !important",
      minHeight: "36px !important",
    },
    [theme.breakpoints.down("sm")]: {
      height: "50px !important",
      minHeight: "50px !important",
    },
    padding: "0 20px",
    borderRadius: "103px !important",
    backgroundColor: theme.palette.secondary.light,
    border: `solid 1px ${theme.palette.border}`,
    boxShadow: "none",
    marginBottom: 8,
  },
}));
